"use strict";

/**
 * @classdesc
 * Wrapperklasse für eine Polygon-Geometrie.
 *
 * @class
 * @abstract
 * @extends gc.gis.geom.GCGeometry
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {T} polygon gewrappte Polygon-Geometrie-Instanz
 */
gc.gis.geom.GCPolygon = function(polygon)
{
    gc.gis.geom.GCGeometry.call(this, polygon);
};
gc.gis.geom.GCPolygon.prototype = Object.create(gc.gis.geom.GCGeometry.prototype);